import { tibiaTheme, missionText, missionInfo, guildOf, BOT_NAMES, CHARACTERS, CHRONICLES, eraRuleset, type CharacterDef, type ChronicleDef } from '@estandarte/theme-tibia';

export const theme = tibiaTheme;
export const S = tibiaTheme.strings;
export { missionText, missionInfo, guildOf, BOT_NAMES, CHARACTERS, CHRONICLES, eraRuleset, type CharacterDef, type ChronicleDef };

/** Crônica (era) de uma partida, pelo id guardado no ruleset. */
export const chronicleOf = (id: string | null | undefined) => CHRONICLES.find((c) => c.id === id) ?? null;

export const guildHex = (color: string) => guildOf(theme, color).hex;
export const guildName = (color: string) => guildOf(theme, color).name;
export const territoryName = (id: string) => theme.territories[id]?.name ?? theme.wildCards[id]?.name ?? id;
/** Nome da carta de território com o símbolo (curingas incluídos). */
export const cardName = (id: string) =>
  theme.wildCards[id] ? `${theme.wildCards[id].name} (curinga)` : `${territoryName(id)} (${S.symbols[theme.territories[id]?.symbol] ?? '?'})`;
/** Símbolo da carta: espada, escudo, cajado ou curinga. */
export const cardSymbol = (id: string) => (theme.wildCards[id] ? 'wild' : theme.territories[id]?.symbol ?? 'wild');
export const regionName = (id: string) => theme.regions[id]?.name ?? id;
export const bossName = (id: string) => theme.bosses[id]?.name ?? id;
export const vocationName = (v: string | null) =>
  v ? (theme.vocations[v as keyof typeof theme.vocations]?.name ?? v) : '';

/** Texto claro ou escuro sobre a cor da guilda. */
export function inkOn(hex: string): string {
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const lum = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  return lum > 0.6 ? '#23263A' : '#F6F6F1';
}

export function errorText(code: string): string {
  return S.errors[code] ?? S.serverErrors[code] ?? code;
}
